module.exports = __webpack_public_path__ + "img/bank-cimb.a70496ff.png";